<script>
  import moment from 'moment';

  export default {
    methods: {
      formatRequestDate: function (dt) {
        return moment(dt).format('DD/MM/YYYY @ HH:mm:ss')
      },
      formatDatePickerDate: function (dt) {
        return moment(dt).format('YYYY-MM-DD')
      },
    }
  }
</script>
